<template>
  <div class="pagination" v-if=visible>
    <!-- 页码 -->
    <el-pagination
      layout="prev, pager, next"
      :total="total"
      :current-page="pageIndex"
      :page-size="pageSize"
      @current-change="pageChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "pagination",
  data() {
    return {};
  },
  props: {
    total: Number,
    pageIndex: Number,
    pageSize: {
      type: Number,
      default: 10
    }
  },
  model: {
    prop: "pageIndex",
    event: "change"
  },
  methods: {
    pageChange(e) {
      this.$emit("change", e);
    }
  },
  computed: {
    visible() {
      return this.total > this.pageSize;
    }
  }
};
</script>
<style lang="less" scoped>
   .pagination{
    margin: 0 auto;
    /deep/.el-pagination{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0,0,0,0.85);
      button{
        height: 24px;
        &:disabled{
          background: none !important;
        }
      }
      .btn-prev,.btn-next{
        background: center center no-repeat none;
        // color: rgba(0,0,0,0.85);
      }
    }
    /deep/.el-pager{
      li{
        min-width: 24px;
        height: 24px ;
        line-height: 24px;
        margin: 0 4px;
        background: none;
        &:hover{
          color: #1677FF; 
        }
      }
      .btn-quicknext{
        line-height: 30px !important;
      }
      .more{
        border: none;
        width: 24px;
      }
    }
      /deep/.active{
      background: #FFFFFF !important;
      border-radius: 2px;
      border: 1px solid #1677FF;
      color: #1677FF;
      width: 24px ;
      height: 24px;
      line-height: 24px;
      }
    
   }
</style>
